import Vue from 'vue';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import VueRouter from 'vue-router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueRouter)


// Routers
const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { 
      path: '/',
      component: () => import('./components/Presentacion.vue')
    },
    { 
      path: '/register-user',
      name: 'register-user',
      component: () => import('./components/Register.vue')
    },    
    { 
      path: '/login',
      name: 'login',
      component: () => import('./components/Login.vue')
    },
    { 
      path: '/usuario',
      name: 'usuario',
      component: () => import('./components/Usuario.vue')
    },
    { 
      path: '/presentacion',
      name: 'presentacion',
      component: () => import('./components/Presentacion.vue')
    },
    { 
      path: '/colocaciones',
      name: 'colocaciones',
      component: () => import('./components/Colocaciones.vue')
    },
    { 
      path: '/formulas',
      name: 'formulas',
      component: () => import('./components/Formulas.vue')
    },
    { 
      path: '/locuciones',
      name: 'locuciones',
      component: () => import('./components/Locuciones.vue')
    },
    { 
      path: '/marcadores',
      name: 'marcadores',
      component: () => import('./components/Marcadores.vue')
    },
    { 
      path: '/refranes',
      name: 'refranes',
      component: () => import('./components/Refranes.vue')
    },
    { 
      path: '/metodologia',
      name: 'metodologia',
      component: () => import('./components/Metodologia.vue')
    },
    { 
      path: '/blog',
      name: 'blog',
      component: () => import('./components/Blog.vue')
    },
    { 
      path: '/creditos',
      name: 'creditos',
      component: () => import('./components/Creditos.vue')
    },
    { 
      path: '/referencias',
      name: 'referencias',
      component: () => import('./components/Referencias.vue')
    },
    { 
      path: '/colocaciones_admin',
      name: 'colocaciones_admin',
      component: () => import('./components/Colocaciones_admin.vue')
    },
    { 
      path: '/formulas_admin',
      name: 'formulas_admin',
      component: () => import('./components/Formulas_admin.vue')
    },
    { 
      path: '/locuciones_admin',
      name: 'locuciones_admin',
      component: () => import('./components/Locuciones_admin.vue')
    },
    { 
      path: '/marcadores_admin',
      name: 'marcadores_admin',
      component: () => import('./components/Marcadores_admin.vue')
    },
    { 
      path: '/refranes_admin',
      name: 'refranes_admin',
      component: () => import('./components/Refranes_admin.vue')
    },
    { 
      path: '/blog_admin',
      name: 'blog_admin',
      component: () => import('./components/Blog_admin.vue')
    },
    { 
      path: '/referencias_admin',
      name: 'referencias_admin',
      component: () => import('./components/Referencias_admin.vue')
    },
    { 
      path: '/presentacion_admin',
      name: 'presentacion_admin',
      component: () => import('./components/Presentacion_admin.vue')
    },
    { 
      path: '/metodologia_admin',
      name: 'metodologia_admin',
      component: () => import('./components/Metodologia_admin.vue')
    },
    { 
      path: '/creditos_admin',
      name: 'creditos_admin',
      component: () => import('./components/Creditos_admin.vue')
    },
  ]
});


// Database connection

import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';
const firebaseConfig = {
  apiKey: "AIzaSyDbik1K2VgFzFzgp_f5qkOChZAFPGmX3SY",
  authDomain: "difraco-69466.firebaseapp.com",
  projectId: "difraco-69466",
  storageBucket: "difraco-69466.appspot.com",
  messagingSenderId: "1081542070932",
  appId: "1:1081542070932:web:ecc63ac878b97c28549a81",
  measurementId: "G-CRNP208TZS"
};


firebase.initializeApp(firebaseConfig);



Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
